import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "@/store";
import { ThemeProvider } from "@context/ThemeContext";
import { NotificationProvider } from "@context/NotificationContext";
import { router } from "./routes";
import "./App.css";

export const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <NotificationProvider>
          <RouterProvider router={router} />
        </NotificationProvider>
      </ThemeProvider>
    </Provider>
  );
};
